"use strict";
// Stremio Plus: "Who's watching?" screen and profile management.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_1 = require("react-router");
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var components_1 = require("stremio/components");
var common_1 = require("stremio/common");
var api_1 = __importDefault(require("stremio/plus/api"));
var activeProfile_1 = require("stremio/plus/activeProfile");
var profileStorage_1 = require("stremio/plus/profileStorage");
var kids_1 = require("stremio/plus/kids");
var avatars_1 = require("./avatars");
var ProfileGate_less_1 = __importDefault(require("./ProfileGate.less"));
var MAX_PROFILES = 5;
var PIN_PATTERN = /^\d{4}$/;
var toActiveProfile = function (profile) { return ({
    id: profile.id,
    name: profile.name,
    avatar: profile.avatar,
    isMain: profile.isMain,
    isKids: profile.isKids,
    maxAge: profile.maxAge,
    ownAddons: profile.ownAddons,
}); };
// The worker and the storage keys only pick up these fields after a reload.
var needsReload = function (current, next) {
    if (current === null)
        return !next.isMain;
    return current.id !== next.id ||
        current.ownAddons !== next.ownAddons ||
        current.isKids !== next.isKids ||
        current.maxAge !== next.maxAge;
};
var ProfileAvatar = function (_a) {
    var profile = _a.profile, className = _a.className;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, ProfileGate_less_1.default['avatar']), style: { backgroundColor: (0, avatars_1.avatarColor)(profile.avatar) } }, profile.name.trim().charAt(0).toUpperCase()));
};
var ProfileGate = function () {
    var _a, _b, _c, _d, _e;
    var t = (0, react_i18next_1.useTranslation)().t;
    var ctxProfile = (0, common_1.useProfile)();
    var authKey = (_b = (_a = ctxProfile.auth) === null || _a === void 0 ? void 0 : _a.key) !== null && _b !== void 0 ? _b : null;
    var _f = (0, react_1.useState)(function () { return !(0, activeProfile_1.isProfileChosen)(); }), open = _f[0], setOpen = _f[1];
    var _g = (0, react_1.useState)({ type: 'pick' }), mode = _g[0], setMode = _g[1];
    var _h = (0, react_1.useState)(null), profiles = _h[0], setProfiles = _h[1];
    var _j = (0, react_1.useState)(null), error = _j[0], setError = _j[1];
    var kidsActive = ((_c = (0, activeProfile_1.getActiveProfile)()) === null || _c === void 0 ? void 0 : _c.isKids) === true;
    // Kids profiles cannot reach the addons and settings pages.
    var location = (0, react_router_1.useLocation)();
    var navigate = (0, react_router_1.useNavigate)();
    (0, react_1.useEffect)(function () {
        if (kidsActive && (0, kids_1.isKidsBlockedPath)(location.pathname)) {
            navigate('/', { replace: true });
        }
    }, [kidsActive, location.pathname]);
    var activate = (0, react_1.useCallback)(function (profile) {
        var current = (0, activeProfile_1.getActiveProfile)();
        var next = toActiveProfile(profile);
        (0, activeProfile_1.setActiveProfile)(next);
        (0, activeProfile_1.setProfileChosen)(true);
        if (needsReload(current, next)) {
            window.location.reload();
        }
        else {
            setOpen(false);
            setMode({ type: 'pick' });
        }
    }, []);
    var loadProfiles = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var list, current_1, fresh, next, e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (authKey === null)
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, api_1.default.listProfiles(authKey)];
                case 2:
                    list = _b.sent();
                    setProfiles(list);
                    setError(null);
                    current_1 = (0, activeProfile_1.getActiveProfile)();
                    fresh = (_a = list.find(function (_a) {
                        var id = _a.id;
                        return id === (current_1 === null || current_1 === void 0 ? void 0 : current_1.id);
                    })) !== null && _a !== void 0 ? _a : list.find(function (_a) {
                        var isMain = _a.isMain;
                        return isMain;
                    });
                    if (fresh) {
                        next = toActiveProfile(fresh);
                        (0, activeProfile_1.setActiveProfile)(next);
                        if (current_1 !== null && needsReload(current_1, next))
                            window.location.reload();
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _b.sent();
                    setError(e_1.message);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [authKey]);
    (0, react_1.useEffect)(function () {
        if (authKey === null) {
            if ((0, activeProfile_1.getActiveProfile)() !== null) {
                (0, activeProfile_1.setActiveProfile)(null);
                (0, profileStorage_1.clearSecondaryProfilesStorage)();
            }
            (0, activeProfile_1.setProfileChosen)(false);
            setProfiles(null);
            return;
        }
        loadProfiles();
    }, [authKey, loadProfiles]);
    (0, react_1.useEffect)(function () {
        var onSwitch = function () {
            setMode({ type: 'pick' });
            setOpen(true);
            loadProfiles();
        };
        window.addEventListener(activeProfile_1.SWITCH_PROFILE_EVENT, onSwitch);
        return function () { return window.removeEventListener(activeProfile_1.SWITCH_PROFILE_EVENT, onSwitch); };
    }, [loadProfiles]);
    var continueWithoutProfiles = (0, react_1.useCallback)(function () {
        var current = (0, activeProfile_1.getActiveProfile)();
        (0, activeProfile_1.setProfileChosen)(true);
        if (current !== null && !current.isMain) {
            (0, activeProfile_1.setActiveProfile)(null);
            window.location.reload();
        }
        else {
            setOpen(false);
        }
    }, []);
    var onProfileClick = (0, react_1.useCallback)(function (profile) {
        if (mode.type === 'manage') {
            if (profile.hasPin) {
                setMode({ type: 'pin', profile: profile, target: profile, then: 'edit' });
            }
            else {
                setMode({ type: 'edit', profile: profile, pin: null });
            }
            return;
        }
        if (profile.hasPin) {
            setMode({ type: 'pin', profile: profile, target: profile, then: 'activate' });
            return;
        }
        // Leaving a kids profile for an unlocked grown-up profile asks for the main profile PIN.
        var main = profiles === null || profiles === void 0 ? void 0 : profiles.find(function (_a) {
            var isMain = _a.isMain;
            return isMain;
        });
        if (kidsActive && !profile.isKids && (main === null || main === void 0 ? void 0 : main.hasPin)) {
            setMode({ type: 'pin', profile: main, target: profile, then: 'activate' });
            return;
        }
        activate(profile);
    }, [mode.type, profiles, kidsActive, activate]);
    if (authKey === null || !open)
        return null;
    return (react_1.default.createElement("div", { className: ProfileGate_less_1.default['profile-gate'] }, mode.type === 'pin' ?
        react_1.default.createElement(PinPrompt, { authKey: authKey, profile: mode.profile, onCancel: function () { return setMode({ type: mode.then === 'edit' ? 'manage' : 'pick' }); }, onValid: function (pin) { return mode.then === 'activate' ? activate(mode.target) : setMode({ type: 'edit', profile: mode.target, pin: pin }); } })
        :
            mode.type === 'edit' ?
                react_1.default.createElement(ProfileEditor, { authKey: authKey, profile: mode.profile, currentPin: mode.pin, mainHasPin: ((_d = profiles === null || profiles === void 0 ? void 0 : profiles.find(function (_a) {
                        var isMain = _a.isMain;
                        return isMain;
                    })) === null || _d === void 0 ? void 0 : _d.hasPin) === true, accountAddons: (_e = ctxProfile.addons) !== null && _e !== void 0 ? _e : [], onDone: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, loadProfiles()];
                                case 1:
                                    _a.sent();
                                    setMode({ type: 'manage' });
                                    return [2 /*return*/];
                            }
                        });
                    }); } })
                :
                    react_1.default.createElement("div", { className: ProfileGate_less_1.default['picker'] },
                        react_1.default.createElement("div", { className: ProfileGate_less_1.default['title'] }, mode.type === 'manage' ? t('PLUS_PROFILES_MANAGE') : t('PLUS_PROFILES_WHO')),
                        error !== null ?
                            react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("div", { className: ProfileGate_less_1.default['error'] },
                                    t('PLUS_PROFILES_LOAD_ERROR'),
                                    " (",
                                    error,
                                    ")"),
                                react_1.default.createElement("div", { className: ProfileGate_less_1.default['actions'] },
                                    react_1.default.createElement(components_1.Button, { className: ProfileGate_less_1.default['secondary-button'], onClick: loadProfiles }, t('PLUS_PROFILES_RETRY')),
                                    // Never lock the user out of the app when the profiles backend is down.
                                    profiles === null ?
                                        react_1.default.createElement(components_1.Button, { className: ProfileGate_less_1.default['secondary-button'], onClick: continueWithoutProfiles }, t('PLUS_PROFILES_SKIP'))
                                        :
                                            null))
                            :
                                null,
                        react_1.default.createElement("div", { className: ProfileGate_less_1.default['profiles'] },
                            (profiles !== null && profiles !== void 0 ? profiles : []).map(function (profile) {
                                var _a;
                                return (react_1.default.createElement(components_1.Button, { key: profile.id, className: ProfileGate_less_1.default['profile'], title: profile.name, onClick: function () { return onProfileClick(profile); } },
                                    react_1.default.createElement(ProfileAvatar, { profile: profile, className: (0, classnames_1.default)((_a = {}, _a[ProfileGate_less_1.default['editing']] = mode.type === 'manage', _a)) }),
                                    react_1.default.createElement("div", { className: ProfileGate_less_1.default['name'] }, profile.name),
                                    react_1.default.createElement("div", { className: ProfileGate_less_1.default['badges'] },
                                        profile.hasPin ? react_1.default.createElement("span", null, t('PLUS_PROFILES_LOCKED')) : null,
                                        profile.isKids ? react_1.default.createElement("span", null, t('PLUS_PROFILES_KIDS')) : null)));
                            }),
                            profiles !== null && profiles.length < MAX_PROFILES && !kidsActive ?
                                react_1.default.createElement(components_1.Button, { className: ProfileGate_less_1.default['profile'], title: t('PLUS_PROFILES_ADD'), onClick: function () { return setMode({ type: 'edit', profile: null, pin: null }); } },
                                    react_1.default.createElement("div", { className: (0, classnames_1.default)(ProfileGate_less_1.default['avatar'], ProfileGate_less_1.default['add']) }, "+"),
                                    react_1.default.createElement("div", { className: ProfileGate_less_1.default['name'] }, t('PLUS_PROFILES_ADD')))
                                :
                                    null),
                        react_1.default.createElement("div", { className: ProfileGate_less_1.default['actions'] },
                            !kidsActive ?
                                react_1.default.createElement(components_1.Button, { className: ProfileGate_less_1.default['secondary-button'], onClick: function () { return setMode({ type: mode.type === 'manage' ? 'pick' : 'manage' }); } }, mode.type === 'manage' ? t('PLUS_PROFILES_DONE') : t('PLUS_PROFILES_MANAGE'))
                                :
                                    null,
                            mode.type === 'pick' && (0, activeProfile_1.isProfileChosen)() ?
                                react_1.default.createElement(components_1.Button, { className: ProfileGate_less_1.default['secondary-button'], onClick: function () { return setOpen(false); } }, t('PLUS_PROFILES_CANCEL'))
                                :
                                    null))));
};
var PinPrompt = function (_a) {
    var _b;
    var authKey = _a.authKey, profile = _a.profile, onCancel = _a.onCancel, onValid = _a.onValid;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _c = (0, react_1.useState)(''), pin = _c[0], setPin = _c[1];
    var _d = (0, react_1.useState)(false), invalid = _d[0], setInvalid = _d[1];
    var _e = (0, react_1.useState)(false), checking = _e[0], setChecking = _e[1];
    var _f = (0, react_1.useState)(null), lockedUntil = _f[0], setLockedUntil = _f[1];
    var locked = lockedUntil !== null;
    // The server unlocks on its own; re-enable the input at the same time.
    (0, react_1.useEffect)(function () {
        if (lockedUntil === null)
            return;
        var timeout = setTimeout(function () {
            setLockedUntil(null);
            setInvalid(false);
        }, Math.max(lockedUntil.getTime() - Date.now(), 0));
        return function () { return clearTimeout(timeout); };
    }, [lockedUntil]);
    var onChange = (0, react_1.useCallback)(function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var value, result, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    value = event.target.value.replace(/\D/g, '').slice(0, 4);
                    setPin(value);
                    setInvalid(false);
                    if (value.length !== 4)
                        return [2 /*return*/];
                    setChecking(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, api_1.default.verifyPin(authKey, profile.id, value)];
                case 2:
                    result = _a.sent();
                    if (result.valid) {
                        onValid(value);
                    }
                    else {
                        setInvalid(true);
                        setLockedUntil(result.lockedUntil ? new Date(result.lockedUntil) : null);
                        setPin('');
                    }
                    return [3 /*break*/, 5];
                case 3:
                    e_2 = _a.sent();
                    console.error('Stremio Plus:', e_2);
                    setInvalid(true);
                    return [3 /*break*/, 5];
                case 4:
                    setChecking(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [authKey, profile.id, onValid]);
    return (react_1.default.createElement("div", { className: ProfileGate_less_1.default['picker'] },
        react_1.default.createElement(ProfileAvatar, { profile: profile }),
        react_1.default.createElement("div", { className: ProfileGate_less_1.default['title'] }, t('PLUS_PROFILES_ENTER_PIN')),
        react_1.default.createElement(components_1.TextInput, { className: (0, classnames_1.default)(ProfileGate_less_1.default['pin-input'], (_b = {}, _b[ProfileGate_less_1.default['invalid']] = invalid, _b)), type: 'password', inputMode: 'numeric', autoFocus: true, value: pin, disabled: checking || locked, onChange: onChange }),
        locked && lockedUntil !== null ?
            react_1.default.createElement("div", { className: ProfileGate_less_1.default['error'] }, t('PLUS_PROFILES_PIN_LOCKED', { time: lockedUntil.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }))
            :
                invalid ?
                    react_1.default.createElement("div", { className: ProfileGate_less_1.default['error'] }, t('PLUS_PROFILES_WRONG_PIN'))
                    :
                        null,
        react_1.default.createElement(components_1.Button, { className: ProfileGate_less_1.default['secondary-button'], onClick: onCancel }, t('PLUS_PROFILES_CANCEL'))));
};
var ProfileEditor = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var authKey = _a.authKey, profile = _a.profile, currentPin = _a.currentPin, mainHasPin = _a.mainHasPin, accountAddons = _a.accountAddons, onDone = _a.onDone;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _j = (0, react_1.useState)((_b = profile === null || profile === void 0 ? void 0 : profile.name) !== null && _b !== void 0 ? _b : ''), name = _j[0], setName = _j[1];
    var _k = (0, react_1.useState)((_c = profile === null || profile === void 0 ? void 0 : profile.avatar) !== null && _c !== void 0 ? _c : 'default'), avatar = _k[0], setAvatar = _k[1];
    var _l = (0, react_1.useState)((_d = profile === null || profile === void 0 ? void 0 : profile.isKids) !== null && _d !== void 0 ? _d : false), isKids = _l[0], setIsKids = _l[1];
    var _m = (0, react_1.useState)((_e = profile === null || profile === void 0 ? void 0 : profile.maxAge) !== null && _e !== void 0 ? _e : 10), maxAge = _m[0], setMaxAge = _m[1];
    var _o = (0, react_1.useState)((_f = profile === null || profile === void 0 ? void 0 : profile.ownAddons) !== null && _f !== void 0 ? _f : false), ownAddons = _o[0], setOwnAddons = _o[1];
    var _p = (0, react_1.useState)((_g = profile === null || profile === void 0 ? void 0 : profile.hasPin) !== null && _g !== void 0 ? _g : false), pinEnabled = _p[0], setPinEnabled = _p[1];
    var _q = (0, react_1.useState)(''), newPin = _q[0], setNewPin = _q[1];
    var _r = (0, react_1.useState)(false), confirmDelete = _r[0], setConfirmDelete = _r[1];
    var _s = (0, react_1.useState)(false), saving = _s[0], setSaving = _s[1];
    var _t = (0, react_1.useState)(null), error = _t[0], setError = _t[1];
    var isMain = (_h = profile === null || profile === void 0 ? void 0 : profile.isMain) !== null && _h !== void 0 ? _h : false;
    var pinChanged = pinEnabled ? newPin.length > 0 : (profile === null || profile === void 0 ? void 0 : profile.hasPin) === true;
    var canSave = name.trim().length > 0 && (!pinEnabled || (profile === null || profile === void 0 ? void 0 : profile.hasPin) || PIN_PATTERN.test(newPin)) && (newPin.length === 0 || PIN_PATTERN.test(newPin));
    var save = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var saved, e_3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setSaving(true);
                    setError(null);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 7, , 8]);
                    return [4 /*yield*/, api_1.default.saveProfile(authKey, {
                            id: profile === null || profile === void 0 ? void 0 : profile.id,
                            name: name,
                            avatar: avatar,
                            isKids: isMain ? undefined : isKids,
                            maxAge: isMain ? undefined : maxAge,
                        })];
                case 2:
                    saved = _b.sent();
                    if (!pinChanged) return [3 /*break*/, 4];
                    return [4 /*yield*/, api_1.default.setPin(authKey, saved.id, pinEnabled ? newPin : null, currentPin !== null && currentPin !== void 0 ? currentPin : undefined)];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    if (!(!isMain && ownAddons !== ((_a = profile === null || profile === void 0 ? void 0 : profile.ownAddons) !== null && _a !== void 0 ? _a : false))) return [3 /*break*/, 6];
                    // A profile switching to its own addons starts from the account ones.
                    return [4 /*yield*/, api_1.default.setAddons(authKey, saved.id, ownAddons ? accountAddons : null)];
                case 5:
                    // A profile switching to its own addons starts from the account ones.
                    _b.sent();
                    _b.label = 6;
                case 6:
                    onDone();
                    return [3 /*break*/, 8];
                case 7:
                    e_3 = _b.sent();
                    setError(e_3.message);
                    setSaving(false);
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); }, [authKey, profile, name, avatar, isKids, maxAge, ownAddons, pinEnabled, newPin, pinChanged, currentPin, accountAddons, isMain, onDone]);
    var remove = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!profile)
                        return [2 /*return*/];
                    if (!confirmDelete) {
                        setConfirmDelete(true);
                        return [2 /*return*/];
                    }
                    setSaving(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, api_1.default.deleteProfile(authKey, profile.id)];
                case 2:
                    _a.sent();
                    onDone();
                    return [3 /*break*/, 4];
                case 3:
                    e_4 = _a.sent();
                    setError(e_4.message);
                    setSaving(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [authKey, profile, confirmDelete, onDone]);
    return (react_1.default.createElement("div", { className: ProfileGate_less_1.default['editor'] },
        react_1.default.createElement("div", { className: ProfileGate_less_1.default['title'] }, profile ? t('PLUS_PROFILES_EDIT') : t('PLUS_PROFILES_ADD')),
        react_1.default.createElement("div", { className: ProfileGate_less_1.default['editor-row'] },
            react_1.default.createElement(ProfileAvatar, { profile: { name: name || '?', avatar: avatar } }),
            react_1.default.createElement(components_1.TextInput, { className: ProfileGate_less_1.default['name-input'], placeholder: t('PLUS_PROFILES_NAME'), maxLength: 32, value: name, onChange: function (event) { return setName(event.target.value); } })),
        react_1.default.createElement("div", { className: ProfileGate_less_1.default['colors'] }, Object.entries(avatars_1.AVATARS).map(function (_a) {
            var _b;
            var key = _a[0], color = _a[1];
            return (react_1.default.createElement(components_1.Button, { key: key, className: (0, classnames_1.default)(ProfileGate_less_1.default['color'], (_b = {}, _b[ProfileGate_less_1.default['selected']] = key === avatar, _b)), style: { backgroundColor: color }, title: key, onClick: function () { return setAvatar(key); } }, null));
        })),
        !isMain ?
            react_1.default.createElement("div", { className: ProfileGate_less_1.default['option'] },
                react_1.default.createElement("div", { className: ProfileGate_less_1.default['option-label'] },
                    t('PLUS_PROFILES_KIDS_OPTION'),
                    react_1.default.createElement("div", { className: ProfileGate_less_1.default['option-hint'] }, t('PLUS_PROFILES_KIDS_HINT'))),
                react_1.default.createElement(components_1.Toggle, { checked: isKids, onClick: function () { return setIsKids(!isKids); } }))
            :
                null,
        !isMain && isKids ?
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: ProfileGate_less_1.default['option'] },
                    react_1.default.createElement("div", { className: ProfileGate_less_1.default['option-label'] }, t('PLUS_PROFILES_MAX_AGE')),
                    react_1.default.createElement("div", { className: ProfileGate_less_1.default['ages'] }, kids_1.KIDS_AGE_OPTIONS.map(function (age) {
                        var _a;
                        return (react_1.default.createElement(components_1.Button, { key: age, className: (0, classnames_1.default)(ProfileGate_less_1.default['age'], (_a = {}, _a[ProfileGate_less_1.default['selected']] = age === maxAge, _a)), onClick: function () { return setMaxAge(age); } }, t('PLUS_PROFILES_AGE', { age: age })));
                    }))),
                !mainHasPin ? react_1.default.createElement("div", { className: ProfileGate_less_1.default['warning'] }, t('PLUS_PROFILES_KIDS_NEEDS_MAIN_PIN')) : null)
            :
                null,
        !isMain ?
            react_1.default.createElement("div", { className: ProfileGate_less_1.default['option'] },
                react_1.default.createElement("div", { className: ProfileGate_less_1.default['option-label'] },
                    t('PLUS_PROFILES_OWN_ADDONS'),
                    react_1.default.createElement("div", { className: ProfileGate_less_1.default['option-hint'] }, t('PLUS_PROFILES_OWN_ADDONS_HINT'))),
                react_1.default.createElement(components_1.Toggle, { checked: ownAddons, onClick: function () { return setOwnAddons(!ownAddons); } }))
            :
                null,
        react_1.default.createElement("div", { className: ProfileGate_less_1.default['option'] },
            react_1.default.createElement("div", { className: ProfileGate_less_1.default['option-label'] }, t('PLUS_PROFILES_PIN_OPTION')),
            react_1.default.createElement(components_1.Toggle, { checked: pinEnabled, onClick: function () { return setPinEnabled(!pinEnabled); } })),
        pinEnabled ?
            react_1.default.createElement(components_1.TextInput, { className: ProfileGate_less_1.default['pin-input'], type: 'password', inputMode: 'numeric', placeholder: (profile === null || profile === void 0 ? void 0 : profile.hasPin) ? t('PLUS_PROFILES_NEW_PIN_OPTIONAL') : t('PLUS_PROFILES_NEW_PIN'), value: newPin, onChange: function (event) { return setNewPin(event.target.value.replace(/\D/g, '').slice(0, 4)); } })
            :
                null,
        error !== null ? react_1.default.createElement("div", { className: ProfileGate_less_1.default['error'] }, error) : null,
        react_1.default.createElement("div", { className: ProfileGate_less_1.default['actions'] },
            react_1.default.createElement(components_1.Button, { className: ProfileGate_less_1.default['primary-button'], disabled: !canSave || saving, onClick: save }, t('PLUS_PROFILES_SAVE')),
            react_1.default.createElement(components_1.Button, { className: ProfileGate_less_1.default['secondary-button'], onClick: onDone }, t('PLUS_PROFILES_CANCEL')),
            profile !== null && !isMain ?
                react_1.default.createElement(components_1.Button, { className: ProfileGate_less_1.default['danger-button'], disabled: saving, onClick: remove }, confirmDelete ? t('PLUS_PROFILES_DELETE_CONFIRM') : t('PLUS_PROFILES_DELETE'))
                :
                    null)));
};
exports.default = ProfileGate;
